

export class DeviceBrandStatusInput implements IDeviceBrandStatusInput {
    /** The auto-generated id of the device brand  master */
    deviceBrandId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDeviceBrandStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceBrandId = _data["deviceBrandId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceBrandStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBrandStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceBrandId"] = this.deviceBrandId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceBrandStatusInput {
    /** The auto-generated id of the device brand  master */
    deviceBrandId: number;
    /** The updated status */
    status: number;
}

